import * as React from "react";

type BadgeVariant = "default" | "secondary" | "outline" | "ghost" | "destructive" | "accent" | "glass";

const variants: Record<BadgeVariant, string> = {
  default: "bg-slate-900 text-white",
  secondary: "bg-slate-100 text-slate-700",
  outline: "border border-slate-200 text-slate-600 bg-transparent",
  ghost: "bg-white/10 text-white border border-white/20",
  destructive: "bg-red-50 text-red-700 border border-red-200",
  accent: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  glass: "bg-white/60 backdrop-blur-md text-slate-700 border border-white/30 shadow-sm",
};

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

export const Badge = ({ className = "", variant = "default", ...props }: BadgeProps) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium tracking-wide ${variants[variant]} ${className}`}
    {...props}
  />
);
